import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'doctor-verification',
  templateUrl: './doctor-verification-component.html',
  imports: [ReactiveFormsModule],
  styleUrls: ['./doctor-verification-component.scss'],
})
export class DoctorVerificationComponent implements OnInit {
  form!: FormGroup;
  certificateFile: File | null = null;
  addressFile: File | null = null;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      certificate: [null, Validators.required],
      addressProof: [null, Validators.required],
    });
  }

  onCertificateSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.certificateFile = input.files[0];
      this.form.patchValue({ certificate: this.certificateFile });
      this.form.get('certificate')?.updateValueAndValidity();
    }
  }

  onAddressSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.addressFile = input.files[0];
      this.form.patchValue({ addressProof: this.addressFile });
      this.form.get('addressProof')?.updateValueAndValidity();
    }
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    console.log('Form valid, ready to send:', {
      certificate: this.certificateFile,
      addressProof: this.addressFile,
    });

    // TODO: send files to Spring Boot backend via FormData + HttpClient
  }
}
